import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'qw-refund-and-cancellation-policy',
  templateUrl: './refund-and-cancellation-policy.component.html',
  styleUrls: ['../../../assets/scss/document.scss', './refund-and-cancellation-policy.component.scss']
})
export class RefundAndCancellationPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
